import { FC, useEffect, MouseEvent } from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import {
  Button,
  CircularProgress,
  Paper,
  TableContainer,
  Typography,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { CustomFormField } from "../../../utilis/component/CustomFormElement";
import { useForm } from "react-hook-form";
import TableComponent from "../../component/TableComponent";
import moment from "moment";
import {
  appointmentlistexcelService,
  appointmentlistpdfServiceDepartmentWise,
  appointmentListReportServiceQa,
} from "../Service";
import { base, clinicId } from "../../../constants";
import useRepotFile from "../../hooks/reportFileHook";
import {
  getAllDepattment,
  getDoctorsByDepartment,
} from "../../../PatientCare/PatientBooking/v2/services";
import useAuthentication from "@hooks/useAuthentication";
import { useLocation, useNavigate } from "react-router-dom";
import moduleRoutes from "@routes/moduleRouteList";
import patientCareRouteList from "../../../PatientCare/routeList";
const PatientReportv2: FC = () => {
  const {
    control,
    reset,
    // handleSubmit,
    getValues,
    watch,
  } = useForm();
  const allData = watch();
  const { user } = useAuthentication();
  const navigate = useNavigate()
  const queryClient = useQueryClient();
  const resetQueryData = (
    key: "departmentsforappointlist" | "doctorsforappointlist",
  ) => {
    queryClient.resetQueries({
      queryKey: [key],
    });
  };
  const { data: departmentData, isLoading: departmentLoading } = useQuery(
    ["departmentsforappointlist"],
    getAllDepattment,
    { refetchOnWindowFocus: false },
  );
  const { data: doctorData, isLoading: doctorLoading } = useQuery(
    ["doctorsforappointlist", allData.department],
    () =>
      getDoctorsByDepartment({
        departmentId: allData.department.departmentId,
      }),
    { refetchOnWindowFocus: false },
  );

  const {
    mutate: getReport,
    data: Data,
    isLoading: appointmentDataLoading,
    reset: resetMutation,
  } = useMutation(appointmentListReportServiceQa);

  const { mutate: getappointmentReportpdf, isLoading: appointmentpdfLoading } =
    useRepotFile({
      apiFunction: appointmentlistpdfServiceDepartmentWise,
      responseFileKey: "file",
    });

  const {
    mutate: getappointmentReportexcel,
    isLoading: appointmentexcelLoading,
  } = useRepotFile({
    apiFunction: appointmentlistexcelService,
    fileType: "xlsx",
  });

  const reportExportPayload = () => {
    const data = getValues();
    return {
      tenantClinicId: user?.tenantClinicId,
      clinicId,
      fromDate: data.fromDate,
      toDate: data.toDate,
      doctor: data.doctor?.doctorName ?? null,
      department: data.department?.departmentName ?? null,
      status: data.status == "All" ? null : data.status,
    };
  };

  const getFiles = (e: MouseEvent<HTMLButtonElement>) => {
    const fileType = e.currentTarget.dataset.filetype;
    const payload = reportExportPayload();

    if (fileType === "pdf") {
      getappointmentReportpdf(payload);
    } else if (fileType === "excel") {
      getappointmentReportexcel(payload);
    }
  };

  const onChange = (d: any) => {
    const data = getValues();
    if (d.target.name == "department") {
      resetQueryData("doctorsforappointlist");
      reset({
        ...data,
        doctor: null,
      });
    }
    console.log("onChange => ", data);
    if (data.fromDate && data.toDate) {
      getReport({
        tenantClinicId: user?.tenantClinicId,
        clinicId,
        fromDate: data.fromDate,
        toDate: data.toDate,
        doctor: data.doctor?.doctorName ?? null,
        department: data.department?.departmentName ?? null,
        status: data.status == "All" ? null : data.status,
      });
    } else {
      resetMutation();
    }
  };

  const clearForm = () => {
    reset({
      fromDate: moment().format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
      status: "All",
    });
    resetMutation();
  };

  useEffect(() => {
    getReport({
      fromDate: moment().format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
      clinicId,
    });
    reset({
      fromDate: moment().format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
      status: "All",
    });
  }, []);

  const statusOptions = [
    "All",
    "BOOKED",
    "Arrived",
    "Booking Confirmed",
    "Encountered",
    "Booking Cancelled",
    "Registered",
    "Emr Started",
    "Billed",
    "Cashed",
    "No Show",
    "Cancelled",
  ];
  const location = useLocation();
  const fromCalendar = location.state?.fromCalendar;
  console.log("fromCalendar => ", fromCalendar);
  return (
    <div className="px-3 py-4 flex flex-col gap-3">
      <Paper>
        <div className="p-4 border-b flex justify-between items-center">
          <Typography color={"primary"} fontWeight={600} fontSize={"1rem"}>
            Appointment List Report
          </Typography>
          {fromCalendar ? <Button variant="outlined" color="error" startIcon={<ArrowBackIcon />} onClick={() => navigate(-1)}>
            Back
          </Button> : <Button onClick={() => navigate(`${base}${moduleRoutes.mainRoute}/${moduleRoutes.patientCare}/${patientCareRouteList.patientBooking}`)}>
            Booking Calendar
          </Button>}
        </div>
        <form
          // onSubmit={handleSubmit(onSubmit)}
          className="grid grid-cols-4 gap-3 p-4"
        >
          <CustomFormField
            control={control}
            element="datepicker"
            name="fromDate"
            fieldProps={{ label: "From Date" }}
            rules={{ required: "From Date is required", onChange }}
          />
          <CustomFormField
            control={control}
            element="datepicker"
            name="toDate"
            fieldProps={{ label: "to Date" }}
            rules={{ required: "to Date is required", onChange }}
          />
          <CustomFormField
            control={control}
            element="autocomplete"
            name="department"
            loading={departmentLoading}
            options={departmentData?.response || []}
            rules={{ required: false, onChange }}
            fieldProps={{ label: "Department ", defaultValue: "All" }}
            autocompleteProps={{
              getOptionLabel: (option) => option.departmentName,
              isOptionEqualToValue: (option, value) => {
                return option.departmentId == value.departmentId;
              },
            }}
          />
          <CustomFormField
            control={control}
            element="autocomplete"
            name="doctor"
            loading={doctorLoading}
            options={doctorData?.response || []}
            rules={{ required: false, onChange }}
            fieldProps={{ label: "Doctor ", defaultValue: "All" }}
            autocompleteProps={{
              getOptionLabel: (option) => option.doctorName,
              isOptionEqualToValue: (option, value) => {
                return option.doctorId == value.doctorId;
              },
            }}
          />

          <CustomFormField
            control={control}
            element="autocomplete"
            name="status"
            options={statusOptions}
            rules={{ required: false, onChange }}
            fieldProps={{ label: "Status ", defaultValue: "All" }}
            autocompleteProps={{
              filterOptions: (options) => options,
            }}
          />
          <div className="col-span-full flex justify-end items-center gap-3">
            <Button color="error" onClick={clearForm}>
              clear
            </Button>
          </div>
        </form>
      </Paper>

      <TableContainer component={Paper}>
        <div className="flex justify-end gap-3 py-2 px-4 border-b">
          <Button
            disabled={appointmentpdfLoading || !Boolean(Data?.response?.length)}
            endIcon={appointmentpdfLoading && <CircularProgress size={18} />}
            data-filetype="pdf"
            onClick={getFiles}
          >
            pdf
          </Button>
          <Button
            disabled={
              appointmentexcelLoading || !Boolean(Data?.response?.length)
            }
            endIcon={
              appointmentexcelLoading && <CircularProgress size={18} />
            }
            data-filetype="excel"
            onClick={getFiles}
          >
            Excel
          </Button>
        </div>
        <TableComponent
          loading={appointmentDataLoading}
          data={Data?.response || []}
          tableProps={heading}
          alertMessage={
            allData?.fromDate == allData?.toDate
              ? `No appointments found on ${moment(allData?.fromDate).format("DD-MM-YYYY")}`
              : `No appointments found from ${moment(allData?.fromDate).format("DD-MM-YYYY")} to ${moment(allData?.toDate).format("DD-MM-YYYY")}`
          }
          paginationChange={(prop) => {
            console.log(prop);
          }}
        />
      </TableContainer>
    </div>
  );
};

export default PatientReportv2;
const heading = [
  { heading: "NAME", key: "patientName" },
  { heading: "Doctor Name", key: "doctor" },
  { heading: "Department", key: "department" },
  { heading: "Mobile No", key: "mobile" },
  { heading: "Status", key: "status" },
  {
    heading: "Date",
    key: "bookingDate",
    date: "DD-MM-YYYY hh:mm A",
    format: "DD/MM/YYYY HH:mm:ss",
  },
];
